import { render, staticRenderFns } from "./demo4.vue?vue&type=template&id=30456626&"
import script from "./demo4.vue?vue&type=script&lang=ts&"
export * from "./demo4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports